import { Card as BaseCard } from "./Card.js";
import { CardFooter } from "./CardFooter.js";
import { CardTitle } from "./CardTitle.js";

export const Card = Object.assign(BaseCard, {
  Footer: CardFooter,
  Title: CardTitle,
});

export { type CardProps } from "./Card.js";
export { CardFooter, type CardFooterProps } from "./CardFooter.js";
export { CardTitle, type CardTitleProps } from "./CardTitle.js";
